import React from 'react';
import UploadCatalogoFornecedor from '../UploadCatalogoFornecedor/UploadCatalogoFornecedor';

type Props = { closeAction: Function; closeActionSimple: Function };

const UploadZesto: React.FC<Props> = (props) => <UploadCatalogoFornecedor {...props}
  source="ZESTO" title="Importar catálogo Zesto"
  instructions="Copie a URL completa do cardápio digital da sua loja no Zesto."
  placeholder="https://pedido.zesto.menu/pt-BR/store/sua-loja/codigo" />;

export default UploadZesto;
